import { Injectable } from '@angular/core';
import { HttpService } from '@core/services/http/http-api';
import { NEW_USER_CREATION, ORGANIZATION, USER_MAINTENANCE } from '@core/constants/api.constants';

@Injectable({
    providedIn: 'root',
})
export class NewUserCreationService {
    constructor(private httpService: HttpService) { }

    private getImContextHeaders(imContext?: { orgId?: string | number; stockroomId?: string | number }): any {
        return imContext
            ? { 'im-context': JSON.stringify(imContext) }
            : undefined;
    }

    private getDefaultLookupParams(): any {
        return {
            limit: 10,
            offset: 0,
            sortBy: 'lastModifiedDate:desc',
        };
    }

    /** Fetches the list of organizations available to the current user. */
    getOrganizations(): Promise<any> {
        return this.httpService.get(NEW_USER_CREATION.GET_ORGS);
    }

    /** Fetches the list of users for the given type (e.g. INTERNALACTIVE). */
    getUsers(type: string = 'INTERNALACTIVE', params?: any): Promise<any> {
        return this.httpService.get(NEW_USER_CREATION.GET_USERS(type), params);
    }

    /** Fetches active users for the clone-user dropdown. */
    getActiveUsers(imContext?: { orgId?: string | number; stockroomId?: string | number }): Promise<any> {
        return this.httpService.get(
            NEW_USER_CREATION.GET_USERS('ACTIVE'),
            this.getDefaultLookupParams(),
            this.getImContextHeaders(imContext)
        );
    }

    /** Fetches stockrooms assigned to the selected clone user. */
    getUserStockrooms(userId: string | number): Promise<any> {
        return this.httpService.get(USER_MAINTENANCE.GET_USER_STOCKROOM(String(userId)));
    }

    /** Fetches stockrooms for the selected organization. */
    getOrganizationStockrooms(
        orgId: string | number,
        imContext?: { orgId?: string | number; stockroomId?: string | number }
    ): Promise<any> {
        return this.httpService.get(
            ORGANIZATION.GET_ONE(String(orgId)),
            undefined,
            this.getImContextHeaders(imContext)
        );
    }

    /** Fetches user groups for the group dropdown. */
    getUserGroups(imContext?: { orgId?: string | number; stockroomId?: string | number }): Promise<any> {
        return this.httpService.get(
            USER_MAINTENANCE.GET_USER_GROUPS,
            this.getDefaultLookupParams(),
            this.getImContextHeaders(imContext)
        );
    }

    /** Submits the new user creation payload. */
    submitNewUserCreation(payload: any): Promise<any> {
        return this.httpService.post(NEW_USER_CREATION.POST_NEW_USER_CREATION, payload);
    }
}
